// ═══════════════════════════════════════════════════════════════
// INICIO · Popup «Incluido en Premium» — modelo (plan-modelo.js)
//
// El popup que sale al pulsar en los carruseles del Inicio algo que el plan
// del usuario no incluye (plan.js). Sus textos los puede cambiar el equipo en
// el backoffice (Inicio → «Popup de elemento bloqueado»): la etiqueta, el
// título, la descripción, las ventajas y los dos botones. Se guarda en el
// Worker (D1 app_config['home_plan_modal']) y llega a la app dentro del feed
// del Inicio (GET /api/home/feed → planModal).
//
//   { kicker, title, desc, pay, more, benefits: [texto] }
//   cada texto = { es, en, …traducciones } (como los de los carruseles)
//
// Un texto vacío = el de fábrica, que la app ya dice en sus 14 idiomas (las
// claves home_v4_plan_* de los locales). Sin ninguna ventaja escrita salen las
// tres de fábrica; con alguna, solo las escritas.
// En el título, «{name}» es el nombre de lo que el usuario ha pulsado.
//
// Lo que NO se edita aquí: el precio y el código de descuento. Salen solos del
// gestor de suscripción (el plan y el cupón vigente), para que el popup nunca
// diga una cifra distinta de la que cobra Stripe.
//
// Fuente única: lo cargan la app (plan.js), el editor del backoffice
// (backoffice/src/lib/homeShowcase.js lo importa tal cual) y el Worker
// (cf-worker/src/lib/homePlanModal.js). Necesita destacados-modelo.js cargado
// antes: de él toma los idiomas. Sin DOM.
// Expone window.TCHomePlanModal.
// TikControl © 2024-2026
// ═══════════════════════════════════════════════════════════════

(function (root) {
  'use strict';

  var Lang = root.TCHomeShowcase;   // idiomas, limpieza y «en el idioma de quien mira»

  // Cada texto: su clave en los locales de la app, su tope y cómo es de fábrica
  // en español e inglés (lo que enseña la vista previa del backoffice mientras
  // el campo está vacío; tienen que coincidir con los locales: lo vigila el test).
  var FIELDS = {
    kicker: { key: 'home_v4_plan_kicker', limit: 40, es: 'Incluido en Premium', en: 'Included in Premium' },
    title: { key: 'home_v4_plan_title', limit: 80, es: '«{name}» está en el plan Premium', en: '“{name}” is part of the Premium plan' },
    desc: { key: 'home_v4_plan_desc', limit: 180, es: 'Premium desbloquea todo TikControl para que tus directos no tengan límites.', en: 'Premium unlocks all of TikControl so your lives have no limits.' },
    pay: { key: 'home_v4_plan_pay', limit: 24, es: 'Pagar ahora', en: 'Pay now' },
    more: { key: 'home_v4_plan_more', limit: 24, es: 'Ver más', en: 'See more' }
  };
  var FIELD_IDS = ['kicker', 'title', 'desc', 'pay', 'more'];

  // Las ventajas de fábrica (si el backoffice no escribe ninguna).
  var BENEFITS = [
    { key: 'home_v4_plan_b1', es: 'Todos los widgets y efectos para tu overlay', en: 'All widgets and effects for your overlay' },
    { key: 'home_v4_plan_b2', es: 'Todos los packs de animaciones LIVE', en: 'Every LIVE animation pack' },
    { key: 'home_v4_plan_b3', es: 'Gaming completo, integraciones y más almacenamiento', en: 'Full gaming, integrations and more storage' }
  ];
  var MAX_BENEFITS = 5;
  var BENEFIT_LIMIT = 70;

  function hasText(value) {
    return !!value && typeof value === 'object' && Lang.EDIT_LANGS.some(function (lang) { return !!String(value[lang] == null ? '' : value[lang]).trim(); });
  }

  /** Lo guardado (o lo que manda el backoffice) → su forma conocida. Nunca lanza. */
  function sanitize(raw) {
    var src = raw && typeof raw === 'object' ? raw : {};
    var out = {};
    FIELD_IDS.forEach(function (id) { out[id] = Lang.cleanLangs(src[id], FIELDS[id].limit); });
    out.benefits = (Array.isArray(src.benefits) ? src.benefits : [])
      .map(function (entry) { return Lang.cleanLangs(entry, BENEFIT_LIMIT); })
      .filter(hasText)
      .slice(0, MAX_BENEFITS);
    return out;
  }

  /** ¿No hay nada escrito? (todo sale de fábrica) */
  function isEmpty(config) {
    var clean = sanitize(config);
    return !clean.benefits.length && FIELD_IDS.every(function (id) { return !hasText(clean[id]); });
  }

  function factory(entry, lang) {
    return String(lang || 'es').slice(0, 2).toLowerCase() === 'es' ? entry.es : entry.en;
  }

  /**
   * Los textos que se pintan, en el idioma de quien mira.
   * `t(clave, porDefecto)` es el traductor de la app; sin él (la vista previa
   * del backoffice), los de fábrica en español o en inglés.
   * → { kicker, title, desc, pay, more, benefits: [texto] }
   */
  function resolve(config, lang, t) {
    var clean = sanitize(config);
    var own = function (entry) { return typeof t === 'function' ? t(entry.key, entry.es) : factory(entry, lang); };
    var out = {};
    FIELD_IDS.forEach(function (id) { out[id] = Lang.localized(clean[id], lang) || own(FIELDS[id]); });
    var written = clean.benefits.map(function (entry) { return Lang.localized(entry, lang); }).filter(Boolean);
    out.benefits = written.length ? written : BENEFITS.map(own);
    return out;
  }

  var api = {
    FIELDS: FIELDS,
    FIELD_IDS: FIELD_IDS,
    BENEFITS: BENEFITS,
    MAX_BENEFITS: MAX_BENEFITS,
    BENEFIT_LIMIT: BENEFIT_LIMIT,
    sanitize: sanitize,
    isEmpty: isEmpty,
    resolve: resolve
  };

  root.TCHomePlanModal = api;
  if (typeof module === 'object' && module && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
